import React from "react";

function ContactUs() {
  return (
    <section class="hero bg-base-200 p-12">
      <div class="hero-content flex-col gap-10">
        <h1 class="text-center text-5xl font-bold leading-[4rem]">Get in Touch with Us!</h1>

        <div class="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
          <div class="card-body">
            <div class="form-control">
              <label class="label">
                <span class="label-text">Email</span>
              </label>

              <input
                type="text"
                placeholder="Email"
                class="input input-bordered"
              />
            </div>

            <div class="form-control">
              <label class="label">
                <span class="label-text">Describe What You Want to Tell Us...</span>
              </label>

              <textarea
                class="textarea input-bordered h-36"
                placeholder="Describe What You Want to Tell Us..."
              />
            </div>

            <div class="form-control mt-6">
              <button class="btn btn-primary">Send Your Response</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
